'use client';
import { type FunctionComponent, useEffect } from 'react';

import { useTranslations } from '@power-core/toolkit';

import { useAppContext } from '@/modules/app-context/use-app-context';
import { useNavigation } from '@/modules/utils/custom-hooks/use-navigation';
import { Flexbox } from '@/ui-components/flexbox/flexbox';
import { LoadingIndicator } from '@/ui-components/loading-indicator/loading-indicator';
import { MarkdownParser } from '@/ui-components/markdown-parser/markdown-parser';
import { Modal } from '@/ui-components/modal/modal';
import { Paragraph } from '@/ui-components/paragraph/paragraph';

import { useReleaseNotesApi } from '../hooks/use-release-notes-api';
import { useReleaseNotesInit } from '../hooks/use-release-notes-init';

export const ReleaseNotesModal: FunctionComponent = () => {
	const { releaseNotesStatus, setReleaseNotesStatus } = useAppContext();
	const { getSearchParams } = useNavigation();
	const { id: documentTypeDocId, isViewedLastNote } = getSearchParams();
	const { isPending, releaseNotes } = useReleaseNotesInit(documentTypeDocId);
	const { setUserViewedNote } = useReleaseNotesApi();
	const t = useTranslations();

	console.log(releaseNotes);

	useEffect(() => {
		if (!releaseNotesStatus[documentTypeDocId]) {
			setUserViewedNote.mutate({ documentTypeDocId });
			setReleaseNotesStatus({ ...releaseNotesStatus, [documentTypeDocId]: true });
		}
	}, []);

	const renderReleaseNotes = () => {
		if (isPending) return <LoadingIndicator />;

		if (releaseNotes?.length === 0) return <Paragraph>{t('T_NO_RELEASE_NOTES')}</Paragraph>;

		return (
			<Flexbox key={documentTypeDocId} direction='col' className='max-w-4xl overflow-y-auto overflow-x-hidden scrollbar-rounded pr-2'>
				{releaseNotes?.map((note, i) => (
					<Flexbox direction='col' key={note.documentId} className='w-full border-b-2 mb-3 pb-3'>
						<Paragraph className='text-n500_light_text my-2'>
							{isViewedLastNote === 'false' && i === 0 && (
								<span className='rounded-full h-4 py-1 px-2 overflow-hidden font-normal text-center max-w-5 mr-2 bg-[#E5EFEC] text-[#21A67A] shadow'>
									{t('T_NEW')}
								</span>
							)}
							{t('T_VERSION')}: {note.version}
						</Paragraph>
						<MarkdownParser markdownString={note.releaseNoteText ?? ''} />
					</Flexbox>
				))}
			</Flexbox>
		);
	};

	return (
		<Modal name='ReleaseNotesModal' title={{ text: t('T_RELEASE_NOTES'), variant: 'h5' }} titleStyle='pt-9' withLine closeButton>
			{renderReleaseNotes()}
		</Modal>
	);
};
